import { render, staticRenderFns } from "./CompensatoryLeaves.vue?vue&type=template&id=ccac9278"
import script from "./CompensatoryLeaves.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports